"use client";

import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { useRouter } from "next/navigation";
export default function PerfilNotFound({ slug }: { slug: string }) {
  const router = useRouter();
  return (
    <Container
      maxWidth="md"
      sx={{
        py: 8,
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          p: {
            xs: 3,
            md: 5,
          },
          borderRadius: 2,
          backgroundColor: "background.paper",
        }}
      >
        <Stack spacing={3} alignItems="center">
          <AlertCircle color="#d32f2f" size={80} strokeWidth={1.5} />

          <Typography
            variant="h4"
            color="error.main"
            textAlign="center"
            fontWeight="bold"
          >
            Perfil não encontrado
          </Typography>

          <Typography variant="body1" color="text.secondary" textAlign="center">
            O perfil <strong>"{slug}"</strong> que você está procurando não
            existe ou não está disponível.
          </Typography>

          <Box
            sx={{
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<ArrowLeft size={20} />}
              onClick={() => router.push("/")}
              size="large"
            >
              Voltar para página inicial
            </Button>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
}
